import { render, staticRenderFns } from "./stock-warehouse.vue?vue&type=template&id=71039c5f&scoped=true"
import script from "./stock-warehouse.vue?vue&type=script&lang=js"
export * from "./stock-warehouse.vue?vue&type=script&lang=js"
import style0 from "./stock-warehouse.vue?vue&type=style&index=0&id=71039c5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71039c5f",
  null
  
)

export default component.exports